/* v34 Bundelsamensteller (werking zoals Glowora /pages/bundel-samensteller, 15 okt 2026).
 * - "Toevoegen" zet een product als nieuwe regel in "Jouw Bundel" (nog niet in de mand); ook hetzelfde product nog eens.
 * - Het minimum (standaard 3) telt regels, net als Glowora; + en − wijzigen alleen het aantal van een regel (min. 1).
 * - Bij het maximum (standaard 6 regels) gaan alle Toevoegen-knoppen uit. Na herladen is de bundel leeg.
 * - Vanaf het minimum wordt de knop actief; de korting (standaard 15%) wordt voorgerekend.
 * - De knop zet alles in één keer in de mand via de Cart AJAX API (NoleeShopify.addItems), met de verborgen
 *   regelkenmerken _noleeOffer (zodat de lade het product herkent) en _nnBundel (cadeaulogica).
 * - Daarna opent onze eigen winkelwagenlade; paper.js luistert naar 'nolee:cart-updated'.
 * De korting zelf rekent Shopify af via een automatische korting (instelling in BUNDEL.md).
 */
(() => {
  'use strict';
  const fmt = cents => {
    const v = Math.round(cents) / 100;
    const [i, d] = v.toFixed(2).split('.');
    return '€' + i.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + d;
  };
  const esc = s => String(s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const ready = () => new Promise(resolve => {
    if (document.documentElement.dataset.noleeReady === 'true' || !window.NoleeShopify) return resolve();
    const done = () => resolve();
    document.addEventListener('nolee:ready', done, { once: true });
    setTimeout(done, 8000);
  });

  function init(root) {
    const min = Math.max(1, parseInt(root.dataset.min, 10) || 3);
    const max = Math.max(min, parseInt(root.dataset.max, 10) || 6);
    const pct = Math.max(0, parseFloat(root.dataset.pct) || 0);
    // 15 okt: vast bedrag per product (centen) heeft voorrang op het percentage.
    const amount = Math.max(0, parseInt(root.dataset.amount, 10) || 0);
    const msgTodo = root.dataset.msgTodo || 'Voeg nog [n] product(en) toe om je bundel compleet te maken.';
    const msgDone = root.dataset.msgDone || 'Minimale bundelgrootte bereikt. Claim nu je korting!';
    const $ = sel => root.querySelector(sel);
    const itemsEl = $('[data-nnb-items]'), msgEl = $('[data-nnb-msg]'), progressEl = $('[data-nnb-progress]');
    const subEl = $('[data-nnb-subtotal]'), discEl = $('[data-nnb-discount]'), totEl = $('[data-nnb-total]');
    const cta = $('[data-nnb-cta]'), ctaTotal = $('[data-nnb-cta-total]'), errEl = $('[data-nnb-error]');
    const cards = [...root.querySelectorAll('[data-nnb-card]')];
    let rows = [];
    let wasComplete = false, busy = false;


    function fromCard(card) {
      const d = card.dataset;
      return { id: d.variantId, offerKey: d.offerKey || '', title: d.title, price: +d.price || 0, compare: +d.compare || 0, image: d.image, url: d.url };
    }
    const unitPrice = r => amount ? Math.max(0, r.price - amount) : r.price - Math.round(r.price * pct / 100);
    // Zoals Glowora: elke klik op Toevoegen is een plek in de bundel (ook hetzelfde product nog eens); het minimum telt plekken.
    const units = () => rows.length;

    function render() {
      const n = units();
      const rest = Math.max(0, min - n);
      const complete = n >= min;
      root.classList.toggle('is-complete', complete);
      msgEl.textContent = complete ? msgDone : msgTodo.replace('[n]', rest).replace('[producten]', rest === 1 ? 'product' : 'producten');
      const p = Math.min(100, n / min * 100);
      cards.forEach(c => { const b = c.querySelector('[data-nnb-add]'); if (b && !b.hasAttribute('data-soldout')) b.disabled = n >= max; });
      progressEl.style.setProperty('--nnb-progress', p + '%');
      progressEl.setAttribute('aria-valuenow', String(Math.min(n, min)));
      // Regels + lege plekken tot het minimum (zoals Glowora's grijze plekken)
      let html = rows.map((r, i) => {
        const was = Math.max(r.compare, r.price);
        return `<div class="nnb__item" data-row="${i}">
          <img src="${esc(r.image)}" alt="" width="60" height="60" loading="lazy">
          <div class="nnb__item-body">
            <p class="nnb__item-title">${esc(r.title)}</p>
            <p class="nnb__item-price">${was > unitPrice(r) ? `<s><span class="nnb-sr">Normale prijs </span>${fmt(was)}</s>` : ''}<b>${fmt(unitPrice(r))}</b></p>
            <div class="nnb__item-actions">
              <div class="nnb__qty">
                <button type="button" data-qty="-1" data-row="${i}" aria-label="Eén ${esc(r.title)} minder">−</button>
                <input type="number" inputmode="numeric" min="1" max="99" value="${r.qty}" data-row="${i}" aria-label="Aantal ${esc(r.title)}">
                <button type="button" data-qty="1" data-row="${i}" aria-label="Eén ${esc(r.title)} meer">+</button>
              </div>
              <button type="button" class="nnb__remove" data-remove="${i}" aria-label="Verwijder ${esc(r.title)} uit je bundel">Verwijderen</button>
            </div>
          </div>
        </div>`;
      }).join('');
      for (let i = 0; i < rest; i++) html += '<div class="nnb__placeholder" aria-hidden="true"><span class="nnb__ph-media"></span><span class="nnb__ph-lines"><span></span><span></span></span></div>';
      itemsEl.innerHTML = html;
      const sub = rows.reduce((s, r) => s + r.price * r.qty, 0);
      const disc = amount ? rows.reduce((s, r) => s + Math.min(amount, r.price) * r.qty, 0) : Math.round(sub * pct / 100);
      subEl.textContent = fmt(sub);
      discEl.textContent = '−' + fmt(disc);
      // Bij een vast bedrag per product tonen we het echte kortingspercentage van deze bundel.
      const discLabel = $('[data-nnb-disc-label]');
      if (amount && discLabel) discLabel.textContent = sub > 0 ? `Korting (${Math.round(disc / sub * 100)}%)` : 'Korting';
      totEl.textContent = fmt(sub - disc);
      ctaTotal.textContent = fmt(sub - disc);
      cta.disabled = !complete || busy;
      cta.setAttribute('aria-disabled', String(!complete || busy));
      if (complete && !wasComplete && n > 0) celebrate();
      wasComplete = complete;
    }

    // Confetti rond de balk zodra het minimum bereikt is (zoals Glowora)
    const confetti = root.querySelector('[data-nnb-confetti]');
    function celebrate() {
      if (!confetti || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      confetti.classList.remove('is-on'); void confetti.offsetWidth; confetti.classList.add('is-on');
      clearTimeout(celebrate.t); celebrate.t = setTimeout(() => confetti.classList.remove('is-on'), 1800);
    }

    function addVariant(card) {
      if (rows.length >= max) return;
      rows.push({ ...fromCard(card), qty: 1 });
      errEl.hidden = true;
      render();
      if (matchMedia('(min-width: 990px)').matches) itemsEl.scrollTop = itemsEl.scrollHeight;
    }

    root.addEventListener('click', e => {
      const add = e.target.closest('[data-nnb-add]');
      if (add && !add.disabled) { addVariant(add.closest('[data-nnb-card]')); return; }
      const q = e.target.closest('[data-qty]');
      if (q) {
        const r = rows[+q.dataset.row]; if (!r) return;
        r.qty = Math.min(99, Math.max(1, r.qty + +q.dataset.qty));
        render(); return;
      }
      const rm = e.target.closest('[data-remove]');
      if (rm) { rows.splice(+rm.dataset.remove, 1); render(); return; }
    });
    root.addEventListener('change', e => {
      const input = e.target.closest('.nnb__qty input'); if (!input) return;
      const r = rows[+input.dataset.row]; if (!r) return;
      const v = parseInt(input.value, 10);
      r.qty = Math.min(99, Math.max(1, v || 1));
      render();
    });

    cta.addEventListener('click', async () => {
      if (busy || units() < min) return;
      busy = true; errEl.hidden = true;
      cta.classList.add('is-loading'); cta.disabled = true;
      const items = rows.map(r => ({ id: Number(r.id), quantity: r.qty, properties: { ...(r.offerKey ? { _noleeOffer: r.offerKey } : {}), _nnBundel: '1' } }));
      try {
        const live = window.NoleeShopify;
        if (live && typeof live.addItems === 'function') {
          await ready();
          await live.addItems(items);
          cta.classList.remove('is-loading'); cta.classList.add('is-done');
          rows = []; wasComplete = false;
          setTimeout(() => {
            document.dispatchEvent(new CustomEvent('nolee:cart-updated', { detail: { open: true, source: 'bundel' } }));
            cta.classList.remove('is-done'); busy = false; render();
          }, 650);
        } else {
          const root_ = document.body.dataset.root || '/';
          const res = await fetch(root_ + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
          const data = await res.json();
          if (!res.ok) throw new Error(data.description || data.message || 'Toevoegen is niet gelukt.');
          rows = [];
          location.href = root_ + 'cart';
        }
      } catch (err) {
        busy = false;
        cta.classList.remove('is-loading', 'is-done');
        errEl.textContent = (err && err.message) || 'Toevoegen is niet gelukt. Probeer het opnieuw.';
        errEl.hidden = false;
        render();
      }
    });

    render();
  }

  const boot = () => document.querySelectorAll('[data-nnb]').forEach(el => { if (!el.dataset.nnbReady) { el.dataset.nnbReady = '1'; init(el); } });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
